export class Interval {
    constructor(start, end) {
        this.start = start;
        this.end = end;
        if (end < start) {
            this.start = end;
            this.end = start;
        }
    }
    intersects(iv) {
        const x1 = this.start;
        const y1 = this.end;
        const x2 = iv.start;
        const y2 = iv.end;
        return !(y1 + 1 < x2 || x1 - 1 > y2);
    }
}
export class Domain {
    constructor(field) {
        this.field = field;
        this.underlying = [];
    }
    clear() {
        this.underlying = [];
    }
    valid() {
        if (this.underlying.length === 0)
            return true;
        let cur = this.underlying[0].start;
        for (let iv of this.underlying) {
            if (iv.start < cur)
                return false;
            cur = iv.end;
        }
        return true;
    }
    add_interval(iv) {
        let intersects = false;
        for (let i = 0; i < this.underlying.length; i++) {
            let iv1 = this.underlying[i];
            if (iv.intersects(iv1)) {
                intersects = true;
                this.underlying[i] = new Interval(Math.min(iv.start, iv1.start), Math.max(iv.end, iv1.end));
                break;
            }
        }
        if (!intersects)
            this.underlying.push(iv);
    }
    union(iv) {
        let initial = this.underlying;
        this.underlying = [];
        initial.push(iv);
        initial.sort((iv1, iv2) => {
            if (iv1.start <= iv2.start)
                return -1;
            if (iv1.start > iv2.start)
                return 1;
            return 0;
        });
        for (let i of initial)
            this.add_interval(i);
    }
    toSQL() {
        if (!this.valid())
            throw new Error(`Invalid domain: ${this.underlying}`);
        let strs = [];
        for (let interval of this.underlying) {
            switch (true) {
                case interval.start == Number.NEGATIVE_INFINITY && interval.end == Number.POSITIVE_INFINITY:
                    break;
                case interval.start == Number.NEGATIVE_INFINITY:
                    strs.push(`${this.field} <= ${interval.end}`);
                    break;
                case interval.end == Number.POSITIVE_INFINITY:
                    strs.push(`${this.field} >= ${interval.start}`);
                    break;
                default:
                    strs.push(`${this.field} >= ${interval.start} AND ${this.field} <= ${interval.end}`);
            }
        }
        return strs.join(' OR ');
    }
    toNone() {
        return `1 <> 1`;
    }
}
